<template>
  <div class="news-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem to=/news/notice><div class="bread">重要通知</div></shBreadItem>
    </shBread>
  </div>
  <div class="news-item">
    <CateGory />
    <div class="news">
      <div class="item">
        <NewsItem :newsItem="newsItem" />
        <div class="pagnation">
          <el-pagination
            v-model:current-page="currentPage"
            v-model:page-size="pageSize"
            @size-change="changeSize"
            @current-change="currentChange"
            :current-page="currentPage"
            :page-sizes="[15, 25, 35, 40]"
            :page-size="pageSize"
            background
            layout="total,  prev, pager, next"
            :total="newsCount"
          >
          </el-pagination>
        </div>
      </div>
      <div class="video">
        <VideoRecommend :VideoReCommend="VideoReCommend" />
      </div>
    </div>
  </div>
</template>

<script>
import CateGory from "./components/news-category.vue";
import NewsItem from "./components/news-item.vue";
import { findNewsNotice } from "@/api/news";
import { findVideoRandom, findVideoRecommand } from "@/api/video";
import { useRouter, useRoute } from "vue-router";
import { nextTick, ref, watch } from "vue";
import VideoRecommend from "@/components/video-recommend.vue";
export default {
  components: { CateGory, NewsItem, VideoRecommend },
  setup() {
    const route = useRoute();
    const newsItem = ref([]);
    //总页数
    const newsCount = ref(0);
    //当前页码
    const currentPage = ref(1);
    //每页数
    const pageSize = ref(20);

    findNewsNotice({
      chID: route.query.firstCate,
      coID: route.query.secondCate,
      clID: route.query.thirdCate,
      size: pageSize.value,
      page: currentPage.value,
    }).then((data) => {
      try {
        newsItem.value = data.result;
        newsCount.value = data?.resultLength[0]?.totalCount;
      } catch (error) {
        console.log(error);
      }
    }).catch((error) => {
              console.log(error);
            });

    const currentChange = (page) => {
      currentPage.value = page;
      try {
        findNewsNotice({
          chID: route.query.firstCate,
          coID: route.query.secondCate,
          clID: route.query.thirdCate,
          size: pageSize.value,
          page: currentPage.value,
        }).then((data) => {
          newsItem.value = data.result;
          newsCount.value = data?.resultLength[0]?.totalCount;
        });
      } catch (error) {
        console.log(error);
      }
      //console.log(page);
    };
    const changeSize = (size) => {
      pageSize.value = size;
    };
    watch(
      () => [route.query, route.fullPath],
      (newValue, oldValue) => {
        findNewsNotice({
          chID: route.query.firstCate,
          coID: route.query.secondCate,
          clID: route.query.thirdCate,
          size: pageSize.value,
          page: currentPage.value,
        })
          .then((data) => {
            newsItem.value = data.result;
            newsCount.value = data?.resultLength[0]?.totalCount;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    );

    const VideoReCommend = ref([]);
    //监控clID并获取相应推荐
    watch(
      () => route.query.thirdCate,
      () => {
        //获取视频推荐

        if (route.query.thirdCate) {
          const clID = route.query.thirdCate?.split(",");
          findVideoRecommand(clID).then((data) => {
            VideoReCommend.value = data.map((item) => {
              return {
                chID: item.chID,
                maID: item.maID,
                coID: item.coID,
                clID: item.clID,
                leName: item.leName,
                leImg:"/web/" + item.leImg,
                coverImg: "/web/" + item.coverImg,
                grade: item.grade.find((ele) => ele._id == item.gradeID),
                id: item._id,
              };
            });
          }).catch((error) => {
              console.log(error);
            });
        } else {
          findVideoRandom(10).then((data) => {
            VideoReCommend.value = data.map((item) => {
              return {
                chID: item.chID,
                maID: item.maID,
                coID: item.coID,
                clID: item.clID,
                leName: item.leName,
                leImg: "/web/" + item.leImg,
                coverImg:"/web/" + item.coverImg,
                grade: item.grade.find((ele) => ele._id == item.gradeID),
                id: item._id,
              };
            });
          }).catch((error) => {
              console.log(error);
            });
        }
      },
      { immediate: true }
    );
    return {
      changeSize,
      currentChange,
      newsItem,
      currentPage,
      newsCount,
      pageSize,
      VideoReCommend,
    };
  },
};
</script>

<style lang="less" scoped>
.news-bread {
  background: @shColor;
  .bread {
    width: 700px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.news-item {
  width: 1240px;
  margin: 0 auto;
  .news {
    display: flex;
    justify-content: space-between;
    .item {
      width: 850px;
      background: #fff;
      .pagnation {
        display: flex;
        justify-content: center;
        margin-top: 25px;
        margin-bottom: 25px;
      }
    }
    .video {
      width: 350px;
      background: #fff;
    }
  }
}
</style>
